(function () {
  if (window.__SQFT_CALC_LOADED__) return;
  window.__SQFT_CALC_LOADED__ = true;

  const root = document.getElementById("sqft-calculator");
  if (!root) return;

  const anchor = document.getElementById("sqft-calculator-anchor");
  const wrap = document.getElementById("sqft-calculator-wrap");
  if (anchor && wrap) anchor.replaceWith(wrap);

  const pieceCoverage = Number(root.dataset.pieceCoverage); // 1 piece kaç sq.ft

  const elToggle = document.getElementById("sqft-toggle");
  const elBody = document.getElementById("sqft-body");

  const elLen = document.getElementById("sqft-length");
  const elWid = document.getElementById("sqft-width");
  const elWaste = document.getElementById("sqft-waste");

  const elProject = document.getElementById("sqft-project");
  const elReco = document.getElementById("sqft-reco");
  const elPieces = document.getElementById("sqft-pieces");
  const elMsg = document.getElementById("sqft-msg");

  const elApply = document.getElementById("sqft-apply");
  const elAdd = document.getElementById("sqft-add");

  function fmt2(x) {
    if (!isFinite(x)) return "—";
    return (Math.round(x * 100) / 100).toString();
  }

  function calcProjectSqft() {
    const L = Number(elLen?.value);
    const W = Number(elWid?.value);
    if (!isFinite(L) || !isFinite(W) || L <= 0 || W <= 0) return 0;

    let sqft = L * W;
    if (elWaste?.checked) sqft *= 1.10;
    return sqft;
  }

  function roundUpSqft(x) {
    if (!isFinite(x) || x <= 0) return 0;
    return Math.ceil(x); // sq.ft’i yukarı yuvarla
  }

  function sqftToPieces(sqft) {
    if (!isFinite(sqft) || sqft <= 0) return 0;
    if (!isFinite(pieceCoverage) || pieceCoverage <= 0) return 0;
    return Math.ceil(sqft / pieceCoverage);
  }

  function findAddToCartForm() {
    return document.querySelector("form[data-type='add-to-cart-form']");
  }

  function setThemeQuantity(qty) {
    const form = findAddToCartForm();
    if (!form) return false;

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return false;

    qtyInput.value = String(qty);
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  async function addToCartFromForm(qty) {
    const form = findAddToCartForm();
    if (!form) throw new Error("Add-to-cart form not found");

    const fd = new FormData(form);
    fd.set("quantity", String(qty)); // pieces

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: fd
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Add to cart failed");
    }
    return res.json();
  }

  function render() {
    const project = calcProjectSqft();
    const recoSqft = roundUpSqft(project);
    const pieces = sqftToPieces(recoSqft);

    if (!project || !recoSqft || !pieces) {
      elProject.textContent = "—";
      elReco.textContent = "—";
      elPieces.textContent = "—";
      return;
    }

    elProject.textContent = fmt2(project);
    elReco.textContent = String(recoSqft);  // recommended sq.ft
    elPieces.textContent = String(pieces);  // pieces needed
  }

  elToggle?.addEventListener("click", () => {
    const open = elBody.style.display !== "none";
    elBody.style.display = open ? "none" : "block";
    elToggle.textContent = open ? "▸" : "▾";
    elToggle.setAttribute("aria-expanded", open ? "false" : "true");
  });

  [elLen, elWid].forEach((el) =>
    el?.addEventListener("input", () => {
      elMsg.textContent = "";
      render();
    })
  );

  elWaste?.addEventListener("change", () => {
    elMsg.textContent = "";
    render();
  });

  elApply?.addEventListener("click", () => {
    elMsg.textContent = "";

    const recoSqft = roundUpSqft(calcProjectSqft());
    const pieces = sqftToPieces(recoSqft);

    if (!recoSqft || !pieces) {
      elMsg.textContent = "Please enter length and width.";
      return;
    }

    const ok = setThemeQuantity(pieces);
    elMsg.textContent = ok
      ? `Quantity set to ${pieces} pieces.`
      : `Calculated ${pieces} pieces (Quantity input not found.)`;
  });

  elAdd?.addEventListener("click", async () => {
    elMsg.textContent = "";

    const recoSqft = roundUpSqft(calcProjectSqft());
    const pieces = sqftToPieces(recoSqft);

    if (!recoSqft || !pieces) {
      elMsg.textContent = "Please enter length and width.";
      return;
    }

    try {
      await addToCartFromForm(pieces);
      elMsg.textContent = `Added ${pieces} pieces to cart.`;
    } catch (e) {
      console.error(e);
      elMsg.textContent = "Could not add to cart. Please try again.";
    }
  });

  render();
})();
